/**
 * 기획전 페이지(page.promo-… 템플릿) 추적 — snippets/az-promo-tracking.liquid 가 promo 페이지에서만 불러온다.
 * 이벤트(모두 dataLayer.push + Shopify.analytics.publish, 개인정보·쿠폰 코드 없음):
 *  - az_promo_view          {promo_id, promo_page, device}                  로드당 1회
 *  - az_promo_scroll        {promo_id, percent(25/50/75/100), device}        구간별 1회
 *  - az_promo_section_view  {promo_id, section_id, section_index, device}    섹션이 '보임'(아래) 상태가 되면 1회
 *  - az_promo_dwell         {promo_id, seconds(10/30/60/120/180), device}   탭이 보이는 시간만 누적, 임계값별 1회
 *  - az_promo_section_dwell {promo_id, section_id, section_index, seconds(정수, 최대 300), device}
 *                           섹션이 '보임'인 누적 시간(탭 숨김 중 제외). 탭이 숨겨지거나(pagehide 포함) 페이지를 떠날 때 섹션당 1회
 * 섹션 '보임' = 섹션의 50% 이상이 화면에 있음. 화면보다 긴 섹션은 화면의 절반 이상을 차지하면 보임으로 본다(50%에 영영 못 미치므로).
 * section_id = 템플릿 JSON 의 섹션 키(예: promo_image_banner_fHejxR) — 템플릿을 고치지 않는 한 그대로. section_index = 페이지 안 순서(1부터).
 */
(function() {
  'use strict';
  var me = document.currentScript;
  var PROMO_ID = me && me.getAttribute('data-az-promo-id');
  if (!PROMO_ID || window.__azPromoTracking) return;
  window.__azPromoTracking = true;
  var PROMO_PAGE = me.getAttribute('data-az-promo-page') || '';

  function device() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'; }
  function track(name, data) {
    var payload = Object.assign({ promo_id: PROMO_ID, device: device() }, data);
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
  }
  function now() { return Date.now(); }
  function tabVisible() { return document.visibilityState === 'visible'; }

  track('az_promo_view', { promo_page: PROMO_PAGE });

  // ── 스크롤 깊이 ──
  var scrollMarks = [25, 50, 75, 100], scrollTicking = false;
  function checkScroll() {
    scrollTicking = false;
    var doc = document.documentElement;
    var max = doc.scrollHeight;
    if (!max) return;
    var pct = (window.scrollY + window.innerHeight) / max * 100;
    while (scrollMarks.length && pct >= scrollMarks[0] - 0.5) track('az_promo_scroll', { percent: scrollMarks.shift() });
    if (!scrollMarks.length) window.removeEventListener('scroll', onScroll);
  }
  function onScroll() { if (!scrollTicking) { scrollTicking = true; requestAnimationFrame(checkScroll); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', checkScroll);  // 스크롤 없이 끝까지 보이는 짧은 페이지

  // ── 페이지 체류(탭이 보이는 시간만) ──
  var dwellMarks = [10, 30, 60, 120, 180], dwellMs = 0, dwellSince = tabVisible() ? now() : 0, dwellTimer = null;
  function dwellTotal() { return dwellMs + (dwellSince ? now() - dwellSince : 0); }
  function checkDwell() {
    var sec = dwellTotal() / 1000;
    while (dwellMarks.length && sec >= dwellMarks[0]) track('az_promo_dwell', { seconds: dwellMarks.shift() });
    if (!dwellMarks.length) { clearInterval(dwellTimer); dwellTimer = null; }
  }
  dwellTimer = setInterval(function() { if (dwellSince) checkDwell(); }, 1000);

  // ── 섹션 노출·섹션 체류 ──
  var sections = [].slice.call(document.querySelectorAll('[id^="shopify-section-template--"]'));
  var states = sections.map(function(el, i) {
    return { el: el, id: el.id.replace(/^shopify-section-template--\d+__/, ''), index: i + 1, seen: false, on: false, since: 0, ms: 0, sent: false };
  });
  function secInfo(s) { return { section_id: s.id, section_index: s.index }; }
  function secStart(s) { if (s.on && !s.since && tabVisible()) s.since = now(); }
  function secStop(s) { if (s.since) { s.ms += now() - s.since; s.since = 0; } }

  if (states.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        var s = states[sections.indexOf(en.target)];
        if (!s) return;
        var vh = window.innerHeight || 1;
        var on = en.isIntersecting && (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= vh * 0.5);
        if (on === s.on) return;
        s.on = on;
        if (on) {
          if (!s.seen) { s.seen = true; track('az_promo_section_view', secInfo(s)); }
          secStart(s);
        } else {
          secStop(s);
        }
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    sections.forEach(function(el) { io.observe(el); });
  }

  // 탭 숨김·페이지 이탈: 체류 정지 + 섹션 체류 1회 발행(중복 방지: sent)
  var flushed = false;
  function flushSections() {
    if (flushed) return;
    flushed = true;
    states.forEach(function(s) {
      secStop(s);
      var sec = Math.min(300, Math.round(s.ms / 1000));
      if (s.sent || sec < 1) return;
      s.sent = true;
      track('az_promo_section_dwell', Object.assign(secInfo(s), { seconds: sec }));
    });
  }
  document.addEventListener('visibilitychange', function() {
    if (tabVisible()) {
      if (!dwellSince) dwellSince = now();
      if (!flushed) states.forEach(secStart);
    } else {
      if (dwellSince) { dwellMs += now() - dwellSince; dwellSince = 0; }
      checkDwell();
      flushSections();
    }
  });
  window.addEventListener('pagehide', flushSections);
})();
